import React from "react"

const Wrapper = ({ children }) => {
  return <div className="bg-second-white flex flex-col gap-2">{children}</div>
}

export default Wrapper
